<template>
  <v-card class="elevation-0">
    <v-card-text style="max-width: 500px">
      <date-time-picker label="Start time" first-day-of-week="1" time-format="HH:mm" v-model="start_time"></date-time-picker>

      <date-time-picker label="Estimated time to complete" first-day-of-week="1" time-format="HH:mm" v-model="end_time"></date-time-picker>

      <v-textarea
        v-model="message"
        label="Message"
      ></v-textarea>

    </v-card-text>
    <v-card-actions>
      <v-btn v-if="!is_set" class="orange" dark @click="start" :loading="loading">Start maintenance</v-btn>
      <v-btn v-if="is_set" class="orange" dark @click="stop" :loading="loading">Stop maintenance</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import DateTimePicker from '../DateTimePicker';
import moment from 'moment';

export default {
  components: {
    DateTimePicker
  },
  data () {
    return {
      message: "",
      start_time: moment().toDate(),
      end_time: moment().toDate(),
      loading: false
    };
  },
  methods: {
    start() {
      this.loading = true;
      var self = this;
      var r = confirm("Start maintenance?")
      if (r == true) {
  			self.$store.dispatch("send_control", {"type": "maintenance", "payload": {type: "start", start_time: moment(this.start_time).unix(), end_time: moment(this.end_time).unix(), message: this.message}}).then((msg) => {
          setTimeout(() => {
            self.$check_maintenance(() => {
              this.loading = false;
            });
          },1000);
          self.$message.success("Maintenance started!");
  			}).catch((msg) => {
        	self.$message.warning("Unable to start maintenance!");
  			});
      } else {
        this.loading = false;
      }
    },
    stop() {
      this.loading = true;
      var self = this;
      var r = confirm("Stop maintenance?")
      if (r == true) {
  			self.$store.dispatch("send_control", {"type": "maintenance", "payload": {type: "end"}}).then((msg) => {
          setTimeout(() => {
            self.$check_maintenance(() => {
              this.loading = false;
            });
          },1000);
  				self.$message.success("Maintenance stopped!");
  			}).catch((msg) => {
        	self.$message.warning("Unable to stop maintenance!");
  			});
      } else {
        this.loading = false;
      }
    }
  },
  computed: {
    maintenance () {
      return this.$store.state.maintenance;
    },
    is_set() {
      return this.maintenance.running;
    }
  }
}
</script>
